







































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import QuestionModel from '@/_models/QuestionModel'
import NotFound from '@/components/common/NotFound.vue'
import * as DownloadCsv from 'vue-json-csv'

@Component({
  components: { DownloadCsv, NotFound },
  computed: {
    ...mapGetters('questions', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('questions', {
      canDelete: 'canDelete',
    }),
  },
})
export default class QuestionList extends Vue {
  // data
  private isPaginated: boolean = true
  private isPaginationSimple: boolean = false
  private paginationPosition: string = 'bottom'
  private defaultSortDirection: string = 'asc'
  private sortIcon: string = 'arrow-up'
  private sortIconSize: string = 'is-small'
  private currentPage: number = 1
  private perPage: number = 10
  private numofPage: number = 1
  private selected: any = {}
  private isFormModalActive: boolean = false
  private searchQuery: string = ''
  private isNew: boolean = false
  private canEdit!: boolean
  private canDelete!: boolean
  private selectedFilter: string = 'title'
  private filedNameLUT: any = {
    _id: 'UUID',
    title: 'label.title',
    content: 'label.content',
  }

  // Export csv setting
  private csvFields: any = ['_id', 'title', 'content']

  // computed
  get questions(): QuestionModel[] {
    const questions = this.$store.state.questions.all.items
    this.numofPage = Math.ceil(questions.length / this.perPage)

    return questions
  }

  get buttonSaveText(): any {
    return this.isNew ? this.$t('button.register') : this.$t('button.save')
  }

  get isLoading(): boolean {
    return this.$store.state.questions.loading
  }

  get filteredData(): QuestionModel[] {
    const targetField: string = this.selectedFilter
    if (!this.questions) {
      return []
    }

    return this.questions.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  // Handle method
  private handleOpenModalEdit(data): void {
    this.isFormModalActive = true
    this.selected = Object.assign({}, data)
    this.isNew = false
  }

  private handleOpenModalAdd(data): void {
    this.isFormModalActive = true
    this.selected = new QuestionModel()
    this.isNew = true
  }

  private async handleApplyChange(): Promise<void> {
    this.$validator.validateAll().then((result) => {
      if (!result) {
        return false
      }
      if (this.isNew) {
        // add item
        this.$store.dispatch('questions/addOne', this.selected).then((resp) => {
          this.isFormModalActive = false
          this.$buefy.toast.open(this.$t('messages.save_success') as string)
        })
      } else {
        // update item
        this.$store
          .dispatch('questions/updateOne', this.selected)
          .then((resp) => {
            this.isFormModalActive = false
            this.$buefy.toast.open(this.$t('messages.update_success') as string)
          })
      }
    })
  }

  private handleConfirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  // Methods
  private convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  private processDelete(data): void {
    this.selected = data
    const index = this.questions.indexOf(this.selected)
    this.$store.dispatch('questions/deleteOne', this.selected).then(() => {
      this.selected = {}
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  // After page created
  private created() {
    this.$store.dispatch('questions/getAll')
  }
}
